import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { About, Footer, Header, Skills, Testimonial, Work, Blogs, BlogDetails, AllBlogs, NotFound, Project, Contact } from './container';
import { Navbar } from './components';
import './App.scss';
import CategoryBlogs from "./container/Blogs/CategoryBlogs";
import AllCategories from "./container/Blogs/AllCategories";
import AllTags from "./container/Blogs/AllTags";
import TagBlogs from './container/Blogs/TagBlogs';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import FloatingActionButton from './components/FloatingActionButton';
import ContactPage from './container/Contact/ContactPage';

const App = () => (
  <Router>
    <div className="app">
      <Navbar />
      <ScrollToTop />
      <Routes>
        {/* Home Route */}
        <Route
          path="/"
          element={
            <>
              <Header />
              <About />
              <Work />
              <Skills />
              <Blogs />
              <Testimonial />
              <Footer />
            </>
          }
        />

        {/* Other Routes */}
        <Route path="/projects" element={<Project />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* Blog Routes */}
        <Route path="/blogs" element={<AllBlogs />} />
        <Route path="/blogs/:slug" element={<BlogDetails />} />
        <Route path="/categories/:category" element={<CategoryBlogs />} />
        <Route path="/categories" element={<AllCategories />} />
        <Route path="/tags" element={<AllTags />} />
        <Route path="/tags/:tag" element={<TagBlogs />} />

        {/* 404 Page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTopButton />
      <FloatingActionButton />
    </div>
  </Router>
);

export default App;